import {DOCUMENT} from '@angular/common';
import {DestroyRef, inject, NgZone, Signal, signal} from '@angular/core';
import {LocalDate, ZonedDateTime} from '@js-joda/core';

/** Локальные часы экземпляра пикера: полночь и возврат к вкладке после сна браузера. */
export function browserCalendarToday(): Signal<LocalDate> {
  const document = inject(DOCUMENT);
  const window = document.defaultView;
  const zone = inject(NgZone);
  const destroyRef = inject(DestroyRef);
  const today = signal(ZonedDateTime.now().toLocalDate());
  let timer: number | undefined;

  const refresh = () => {
    const now = ZonedDateTime.now();
    const date = now.toLocalDate();
    if (!today().equals(date)) {
      zone.run(() => today.set(date));
    }
    if (window) {
      window.clearTimeout(timer);
      // Следующая местная полночь, а не 24 часа: учитываем переходы летнего времени.
      const midnight = date.plusDays(1).atStartOfDay(now.zone());
      const delay = midnight.toInstant().toEpochMilli() - now.toInstant().toEpochMilli();
      timer = window.setTimeout(refresh, Math.max(1, delay));
    }
  };
  const visible = () => {
    if (!document.hidden) {
      refresh();
    }
  };

  // Долгий таймер не удерживает Angular в нестабильном состоянии.
  zone.runOutsideAngular(() => {
    refresh();
    document.addEventListener('visibilitychange', visible);
    window?.addEventListener('focus', refresh);
  });
  destroyRef.onDestroy(() => {
    window?.clearTimeout(timer);
    document.removeEventListener('visibilitychange', visible);
    window?.removeEventListener('focus', refresh);
  });
  return today.asReadonly();
}
